import React from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap"

const PdfPreviewModal = ({ isOpen, toggle, pdfUrl, title = "PDF Preview" }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>

      <ModalBody>
        {!pdfUrl ? (
          <div className="text-center py-5">
            <Spinner />
            <p className="text-muted mt-2">Loading document…</p>
          </div>
        ) : (
          <iframe
            src={pdfUrl}
            title="PDF Preview"
            style={{
              width: "100%",
              height: "450px",
              border: "none",
            }}
          />
        )}
      </ModalBody>

      <ModalFooter>
        {pdfUrl && (
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            download
            className="btn btn-success"
          >
            <i className="bx bx-download me-1"></i> Download
          </a>
        )}
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default PdfPreviewModal
